import axiosInstance from '@/utils/api.js'

var state = {
  techParams: [],
  settingTechParams: [],
  settingTechParamsSlinks: []
}

var getters = {
  TECH_PARAMS: (state) => {
    return state.techParams
  },
  SETTING_TECH_PARAMS: (state) => {
    return state.settingTechParams
  },
  SETTING_TECH_PARAMS_SLINKS: (state) => {
    return state.settingTechParamsSlinks
  }
}

var mutations = {
  SET_TECH_PARAMS: (state, payload) => {
    state.techParams = payload
  },
  SET_SETTING_TECH_PARAMS: (state, payload) => {
    state.settingTechParams = payload
  },
  SET_SETTING_TECH_PARAMS_SLINKS: (state, payload) => {
    state.settingTechParamsSlinks = payload
  }
}

var actions = {
  GET_TECH_PARAMS: async (context, payload) => {
    let result = await axiosInstance.get('/users/tech_params?user_id=' + payload.user_id + '&account_id=' + payload.account_id)
    if (result.status === 200) {
      context.commit('SET_TECH_PARAMS', result.data)
    }
  },
  CREATE_TECH_PARAMS: (context, payload) => {
    return axiosInstance.post('/users/tech_params', payload)
  },
  UPDATE_TECH_PARAMS: (context, payload) => {
    return axiosInstance.put('/users/tech_params', payload)
  },
  DELETE_TECH_PARAMS: (context, payload) => {
    return axiosInstance.delete('/users/tech_params?tech_param_id=' + payload.id + '&slink_id=' + payload.slink_id)
  },
  GET_SETTING_TECH_PARAMS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/tech_params')
    if (result.status === 200) {
      context.commit('SET_SETTING_TECH_PARAMS', result.data)
    }
  },
  GET_SETTING_TECH_PARAMS_SLINKS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/tech_params_slinks?user_id=' + payload.user_id + '&account_id=' + payload.account_id)
    if (result.status === 200) {
      context.commit('SET_SETTING_TECH_PARAMS_SLINKS', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/techParams.js